import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="dashboard-header">
      <div className="header-content">
        <div className="header-left">
          <Link to="/" className="logo">
            <h2>Kanivu CMS</h2>
          </Link>
          <nav className="main-nav">
            <Link to="/">Dashboard</Link>
            <Link to="/posts">Posts</Link>
            <Link to="/configurations">Configurations</Link>
            <Link to="/posts/new" className="btn-new-post">+ New Post</Link>
          </nav>
        </div>
        
        <div className="header-right">
          <span className="user-info">Welcome, {user?.username}</span>
          <button onClick={handleLogout} className="btn-logout">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;